import {
  CancelOutlined,
  DeleteForever,
  Edit,
  ViewHeadline,
} from "@mui/icons-material";
import { Tooltip } from "@mui/material";
import localize from "../../common/localize";

export default function ActionButtons({
  onClickForEditButton,
  onclickForDeleteButton,
  detailsButtonText,
  onClickForDetailButton,
  hideEditButton,
  hideDeleteButton,
  showCancelIcon,
  cancelButtonText,
  buttons, // [{name, icon, action}]
  style,
  disabled,
}) {
  return (
    <div className={style ?? "flex justify-center gap-2"}>
      {detailsButtonText &&
        (disabled ? (
          <button
            className={`btn app_button app_general_button_data btn-sm shrink flex-nowrap ${
              hideEditButton === true && hideDeleteButton === true
                ? "unique_action_button"
                : ""
            }`}
            disabled={disabled}
            onClick={onClickForDetailButton}
          >
            <ViewHeadline style={{ width: "16px", height: "16px" }} />
          </button>
        ) : (
          <Tooltip title={detailsButtonText}>
            <button
              className={`btn app_button app_general_button_data btn-sm shrink flex-nowrap ${
                hideEditButton === true && hideDeleteButton === true
                  ? "unique_action_button"
                  : ""
              }`}
              disabled={disabled}
              onClick={onClickForDetailButton}
            >
              <ViewHeadline style={{ width: "16px", height: "16px" }} />
            </button>
          </Tooltip>
        ))}

      {!hideEditButton &&
        (disabled ? (
          <button
            className="btn app_button app_general_button_data btn-sm shrink flex-nowrap"
            onClick={onClickForEditButton}
            disabled={disabled}
          >
            <Edit style={{ width: "16px", height: "16px" }} />
          </button>
        ) : (
          <Tooltip title={localize.edit}>
            <button
              className="btn app_button app_general_button_data btn-sm shrink flex-nowrap"
              onClick={onClickForEditButton}
              disabled={disabled}
            >
              <Edit style={{ width: "16px", height: "16px" }} />
            </button>
          </Tooltip>
        ))}

      {!hideDeleteButton &&
        (disabled ? (
          <button
            className="btn btn-error app_general_button_data btn-sm shrink flex-nowrap"
            onClick={onclickForDeleteButton}
            disabled={disabled}
          >
            {showCancelIcon ? (
              <CancelOutlined style={{ width: "16px", height: "16px" }} />
            ) : (
              <DeleteForever style={{ width: "16px", height: "16px" }} />
            )}
          </button>
        ) : (
          <Tooltip
            title={
              showCancelIcon
                ? cancelButtonText
                  ? cancelButtonText
                  : localize.tooltip_cancel
                : localize.tooltip_delete
            }
          >
            <button
              className="btn btn-error app_general_button_data btn-sm shrink flex-nowrap"
              onClick={onclickForDeleteButton}
              disabled={disabled}
            >
              {showCancelIcon ? (
                <CancelOutlined style={{ width: "16px", height: "16px" }} />
              ) : (
                <DeleteForever style={{ width: "16px", height: "16px" }} />
              )}
            </button>
          </Tooltip>
        ))}

      {buttons &&
        buttons.length > 0 &&
        buttons.map((button) =>
          disabled ? (
            <button
              className="btn app_button app_general_button_data btn-sm shrink flex-nowrap"
              onClick={button.action}
              disabled={disabled}
            >
              {button.icon}
            </button>
          ) : (
            <Tooltip key={button.name} title={button.name}>
              <button
                className="btn app_button app_general_button_data btn-sm shrink flex-nowrap"
                onClick={button.action}
                disabled={disabled}
              >
                {button.icon}
              </button>
            </Tooltip>
          )
        )}
    </div>
  );
}
